import { SDKSettingsContext } from '@contexts/sdkSettings/SDKSettingsContext';
import * as React from 'react';

export const useSDKSettings = () => React.useContext(SDKSettingsContext);
